(function ($) {
"use strict";
    
    $(document).ready(function () {
      videopopup();
      equalheight('.product--details .product--title');   
      
      $('.header--search').on('click', function () {
     equalheight('.product--details .product--title');
  });
    });

    $(window).resize(function () {
		setTimeout(function() {
			equalheight('.product--details .product--title');
		}, 360);  
	});

    $(window).on('scroll load', runCounterWhenVisible);



    function videopopup() {
      $(".play_video_btn ").off("click").on("click", function() {
        var linkAttrib = $(this).attr("data-pop");
        if (linkAttrib == "videoPopup") {
          var videoPopupSrc = $(this).attr("data-src");
          $(".videoPopupDetail iframe").attr("src", videoPopupSrc);
        }
        $("#" + linkAttrib).addClass("popVisible");
        if (typeof videoPopupSrc !== "undefined" && videoPopupSrc.includes("youtube.com")) {
          $(".popupMain").addClass("youtube-video-pp");
        }
        $("body").addClass("pop_bodyFixed");
      });
    
      $(".closePopup, .pop_overlayer").click(function() {
        $(".videoPopupDetail").length > 0 && $(".videoPopupDetail").find("iframe").attr("src", " ");
        $(".popupMain").removeClass("popVisible");
        $("body").removeClass("pop_bodyFixed");
      });
    }


    function runCounterWhenVisible() {
        $('.number-counter').each(function () {
            var $el = $(this);

            if ($el.data('counted')) return;

            var elementTop = $el.offset().top;
            var elementBottom = elementTop + $el.outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();

            if (elementBottom > viewportTop && elementTop < viewportBottom) {

                $el.data('counted', true);

                // clean number (remove commas etc.)
                var finalNumber = parseInt($el.text().replace(/[^0-9]/g, ""));

                // add comma formatter
                function formatNumber(num) {
                    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }

                // animate
                $({ countNum: 0 }).animate(
                    { countNum: finalNumber },
                    {
                        duration: 3000,
                        easing: 'swing',
                        step: function () {
                            $el.text(formatNumber(Math.ceil(this.countNum)));
                        },
                        complete: function () {
                            $el.text(formatNumber(finalNumber));
                        }
                    }
                );
            }
        });
    }

    /*-----| B.Equal Height |-----*/
    var equalheight = function (container) {
        var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = [],
        $el,
        topPosition = 0;

        $(container).each(function () {
            $el = $(this);
            $el.height('auto');
            topPosition = $el.position().top;

            if (currentRowStart !== topPosition) {
                /* Set heights for the previous row */
                for (var i = 0; i < rowDivs.length; i++) {
                    rowDivs[i].height(currentTallest);
                }

                /* Reset for new row */
                rowDivs = [];
                currentRowStart = topPosition;
                currentTallest = $el.height();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = Math.max(currentTallest, $el.height());
            }
        });

        /* Set height for the last row */
        for (var i = 0; i < rowDivs.length; i++) {
            rowDivs[i].height(currentTallest);
        }
    };
    


    

})(jQuery);



document.addEventListener("DOMContentLoaded", function () {

    const videos = document.querySelectorAll(".video-grid-video");

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            const video = entry.target;

            if (entry.isIntersecting) {

                video.play();

            } else {

                video.pause();

            }

        });

    }, {
        threshold: 0.3
    });

    videos.forEach((video) => {
        observer.observe(video);
    });

});